const cotizacionPublica = {
  path: "/public",
  component: () =>
    import(
      /* webpackChunkName: 'Public-Layout' */ "@/modules/public/layouts/PublicLayout"
    ),
  children: [
    {
      path: "cotizar",
      component: () =>
        import(
          /* webpackChunkName: 'Public-Layout-Cotizar' */ "@/modules/public/layouts/PublicLayoutCotizar"
        ),
      children: [
        {
          path: "",
          name: "cotizacion-publica",
          component: () =>
            import(
              /* webpackChunkName: 'Cotizacion-Publica' */ "@/modules/public/pages/cotizacion/"
            ),
        },
      ],
    },
    {
      path: "cotizacion",
      component: () =>
        import(
          /* webpackChunkName: 'Cotizacion-Publica-Preview-Layout' */ "@/modules/public/layouts/PublicLayoutPreview"
        ),
      children: [
        {
          path: ":token/preview",
          name: "cotizacion-publica-show",
          component: () =>
            import(
              /* webpackChunkName: 'Cotizacion-Preview' */ "@/modules/public/pages/cotizacion/CotizacionPreview"
            ),
        },
        {
          path: "unidades/:token",
          name: "cotizacion-publica-unidades-show",
          component: () =>
            import(
              /* webpackChunkName: 'Cotizacion-Unidades-Preview' */ "@/modules/public/pages/cotizacion/unidades"
            ),
        },
      ],
    },
  ],
};

export default cotizacionPublica;
